import { render, staticRenderFns } from "./PeriodSelect.vue?vue&type=template&id=31b1db2a&"
import script from "./PeriodSelect.vue?vue&type=script&lang=ts&"
export * from "./PeriodSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../../backups/absys-worktrees/2026-09-12-colomer-web/src/web/AbsysERP.WebApi/ClientApp/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports